import { useFeatureIsOn as useFeatureIsOnBase } from "@growthbook/growthbook-react";

import type { AppFeatures } from "@/app/featureFlags/types";
import { growthbook } from "@/lib/growthbook";

export function isFeatureOn(featureKey: keyof AppFeatures) {
  return growthbook.isOn(featureKey);
}

export function useFeatureIsOn(featureKey: keyof AppFeatures) {
  return useFeatureIsOnBase(featureKey);
}
